import '../index.css';
var styles = {
  "card": "bp_card_module_card--ae348",
  "dropshadow-1": "bp_card_module_dropshadow-1--ae348",
  "dropshadow-3": "bp_card_module_dropshadow-3--ae348"
};
export { styles as default };